import Plyr from 'plyr';
import { debounce as _debounce } from 'underscore';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin( ScrollTrigger);

// Vimeo Player SDK:  https://developer.vimeo.com/player/sdk
const console = window.console;

export default class{

    constructor( options ) {
        this.defaults = {
        	$el: false,
        	trackGAEvents: true,

        	scrollaAutopause: false,
        	debug: true
        }
        this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.namespace 		= 	'embed_plyr_player';
		this.$el 			= 	this.options.$el;
		this.main			=   this.options.main;

		this.$window 		= 	$(window);

		this.init( true );
    }

    init( b ){
    	this.$iframe = this.$el.find( 'iframe' );

    	if ( this.$iframe.length <= 0 ){
    		this.onError(  {name: 'missing element', message:'iframe is missing'} );
    		return;
    	}

    	if ( !this.$el.hasClass( 'is-plyr') ){
    		console.log( 'this is not a PLYR embed' );
    		return;
    	}


    	this.initPlayer( b );
    	this.addEvents( b );

		// if the placeholder (video-poster) is specified, set video embed to visible
		if ( this.$el.find( '.placeholder' ).length > 0 ){
			this.$el.addClass( 'video-load' );
		}    	
	}

	initPlayer( b ){
		if ( b ){
			const player = new Plyr( this.$el.find( '.plyr__video-embed' ), {
				debug: this.options.debug,
                iconUrl: $( 'body' ).attr( 'data-theme-url' ) + '/assets/img/plyr/plyr.svg',
                //controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'settings', 'pip', 'airplay', 'fullscreen'],
                controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'fullscreen']
			});

			this.player = player;
		}
		else{
			if ( this.player){
				this.player.destroy();
				this.player = null;
			}
		}
		this.initScrollAutoPause(b)
	}

	initScrollAutoPause( b ){
		if ( ! this.options.scrollAutopause ){
			return;
		}


		if ( b ){
			this.scrollTriggerId = this.namespace + '_' + Math.random();
			
			ScrollTrigger.create({
				id: this.scrollTriggerId
				,scrub: true
				,trigger: this.$el
				,toggleClass: 'auto-in-view'
				,scroller: $(this.main.options.$scroll_el)
				,onToggle: (e) => {
					//console.log( e );
					this.forceAutoPause( !e.isActive );
				}
				//,markers: true
			});
		}
		else{
			ScrollTrigger.getById( this.scrollTriggerId ).kill();
		}
	}

	 //---------------------------------------- EVENTS ---------------------------------------//
	addEvents( b ){
		const player = this.player;
		if ( b ){
			player.on('ready', (event) => {
	  			//const instance = event.detail.plyr;
				//console.log( 'PLYR READY' );
				//console.log( event );
			});
			player.on('play', (event) => {
		    	if ( this.options.trackGAEvents ){
					this.main.setGAEvent(  'Video Play', 'Click', this.$iframe.attr( 'src' ) , document.location.href  );
		    	}
			});
			player.on('pause', (event) => {
		    	if ( this.options.trackGAEvents ){
					this.main.setGAEvent(  'Video Pause', 'Click', this.$iframe.attr( 'src' ) , document.location.href  );
		    	}
			});
		}
		else{
			player.off('ready', (event) => {
	  			//const instance = event.detail.plyr;
				//console.log( 'PLYR READY' );
				//console.log( event );
			});
			player.off('play', (event) => {
		    	if ( this.options.trackGAEvents ){
					this.main.setGAEvent(  'Video Play', 'Click', this.$iframe.attr( 'src' ) , document.location.href  );
		    	}
			});
			player.off('pause', (event) => {
		    	if ( this.options.trackGAEvents ){
					this.main.setGAEvent(  'Video Pause', 'Click', this.$iframe.attr( 'src' ) , document.location.href  );
		    	}
			});
		}
		this.debounceResize(b);
	}

    debounceResize( b ){
		if ( b ){
			// debounce resize
			this._debResize = _debounce( () => {
				this.onResize();
			}, 77 );
			this.$window.on( 'resize', this._debResize );

			this.onResize()
		}
		else{
			if ( this._debResize ){
				this._debResize.cancel();
				this.$window.off( 'resize', this._debResize );
			}        
		}
    }

    onError( error ){
    	let str = this.namespace + ' : ';
		switch (error.name) {
			case 'PasswordError':
				str += 'The video is password-protected';
			break;
			case 'PrivacyError':
				str += 'The video is private';
			break;
			default:
				str += error.message;
		}
		console.log( error );
		console.log( str );
    }

    onResize(){
    	const w_video = parseInt( this.$iframe.attr('width')  ), 
    		  h_video = parseInt( this.$iframe.attr('height') );

		if ( this.options.autopause ){
			ScrollTrigger.refresh();
		}
    }

    //---------------------------------------- METHODS ---------------------------------------//
    play( b ){
    	if ( b ){
    	}
    	else{
    	}
	}

    togglePlay(){
    }

    // fired by ScrollTrigger if this.options.autopause is true
    forceAutoPause( b ){
    }

    destroy(){
    	this.init( false );
    }

}


